import PostBoxForm from "./PostBoxForm";

const index = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          {/* <!-- Ls widget --> */}
          <div className="ls-widget">
            <div className="tabs-box">
              <div className="widget-title">
                <h4>Post a Job</h4>
              </div>

              <div className="widget-content">
                {/* <PostJobSteps /> */}
                {/* End job steps form */}
                <PostBoxForm />
                {/* End post box form */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
